export const GET_INSURANCECLAIMPAGE_BY_ID_METHOD = (id: any, preview: boolean) => `
query {
  insuranceClaimPage(id: "${id}", preview: ${preview}) {
  sys {
        id
      }
    linkedFrom {
        pageCollection(limit: 1) {
          items {
            sys {
              id
            }
          }
        }
      }
    insuranceName
    heading
    subheader
    preamble
    ivMainImage
    topImage
    heroContentAreaCollection {
      items {
        __typename
        ... on Link {
          sys {
            id
          }
        }
      }
    }
    availableForAudiencesCollection {
        items {
          audianceId
        }
    }
    uspHeading
    fallbackUspHeading
    usps
    personalizedMessageFallback {
      __typename
      ...on RestrictedRichTextBlock{sys{id}}
  }
  personalizedMessageVariantsCollection {
      items {
        __typename
        ...on RestrictedRichTextBlock{sys{id} audienceCollection{items{audianceId}}}
      }
  }
    personalizedClaimLinksCollection(limit: 20){
        __typename
    items{
      linkText
      globalLinkItem
      reference {
        ...on Page {
          slug
        }
        ...on FileBlock
        {
          imageVaultFile
        }
      }
      url
      newTab
      ikon
      variant
      audienceCollection{
        items{
          audianceId
        }
      }
    }
  }
    changeSectorLabel
    mainAreaCollection {
        items {
            __typename
            ... on RichTextBlock {sys {id}}
            ... on AccordionBlock {sys {id}}
            ... on FileBlock {sys {id}}
            ... on InformationBlock {sys {id}}
            ... on TeaserBlock {sys {id}}
            ... on Link {sys {id}}
            ... on Sectionblock {sys {id}}
            ... on Videoblock {sys {id}}
            ... on TableBlock {sys {id}}
            ... on Page {sys {id}}
            ... on PersonalizationBlock {sys {id}}
            ... on TimelineBlock {sys {id}}
            ...on ImageBlock {sys {id}}
            ...on FileListBlock {sys{id}}
            ... on BannerBlock {sys {id}}
            ... on ContactUsBlock {
            sys {
              id
            }
          }
          ... on LinkTeaserBlock {sys {id}}
        }
    }
    relatedContentHeading
    relatedContentSmallImages
    relatedContentCollection {
        items {
            __typename
            ... on TeaserBlock {sys {id}}
            ... on Page {sys {id}}
        }
    }
  }
}
`;
